import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../lib/routes'
import { useLang } from '../lib/useLang'

export default function PilotDemo() {
  const navigate = useNavigate()
  const { t } = useLang()
  const scope = t('lp.pilot.scope') || []
  const outcomes = t('lp.pilot.outcomes') || []
  return (
    <section id='pilot' className='hairline-bottom'>
      <div className='mx-auto max-w-6xl px-6 lg:px-10 py-24 md:py-32'>
        <div data-reveal className='label-eyebrow mb-10'>{t('lp.pilot.eyebrow')}</div>

        <h2 data-reveal className='headline-display text-3xl md:text-5xl lg:text-[3.4rem] max-w-3xl'>
          {t('lp.pilot.titlePart1')}
          <br />
          <span className='text-muted'>{t('lp.pilot.titlePart2')}</span>
        </h2>

        <div className='mt-12 md:mt-16 grid md:grid-cols-2 gap-10 md:gap-14'>
          <div data-reveal>
            <p className='text-[1.05rem] leading-[1.75] text-ink/80 max-w-xl'>
              {t('lp.pilot.lead')}
            </p>

            <div className='mt-8'>
              <div className='label-eyebrow mb-4'>{t('lp.pilot.scopeLabel')}</div>
              <div className='flex flex-wrap gap-2'>
                {(Array.isArray(scope) ? scope : []).map((s, i) => (
                  <span
                    key={i}
                    className='mono text-[0.78rem] tracking-[0.04em] px-3 py-2 border border-[var(--hairline-strong)] rounded-[2px] bg-white/40'
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div data-reveal className='outcome' style={{ transitionDelay: '0.12s' }}>
            <span className='outcome-badge'>{t('lp.pilot.riskBadge')}</span>
            <p className='text-[1.02rem] leading-[1.75] text-ink/80'>
              {t('lp.pilot.riskBody')}
            </p>
            <button
              type='button'
              onClick={() => navigate(RoutesEnum.CONTACT)}
              className='btn-primary mt-8'
            >
              {t('lp.finalCta.btnPrimary')}
            </button>
          </div>
        </div>

        <div data-reveal className='label-eyebrow mt-16 md:mt-20 mb-6'>
          {t('lp.pilot.outcomesLabel')}
        </div>
        <div className='grid md:grid-cols-2 gap-6'>
          {(Array.isArray(outcomes) ? outcomes : []).map((o, i) => (
            <div
              key={i}
              data-reveal
              className='outcome'
              style={{ transitionDelay: `${i * 0.1}s` }}
            >
              <span className={`outcome-badge ${i === 0 ? '' : 'outcome-badge-alt'}`}>
                {o.badge}
              </span>
              <h3 className='text-[1.5rem] md:text-[1.8rem] font-normal tracking-[-0.015em] leading-[1.2]'>
                {o.title}
              </h3>
              <ul>
                {(Array.isArray(o.items) ? o.items : []).map((it, j) => (
                  <li key={j}>{it}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
